import React, { useEffect } from "react";
import styles from "./Home.module.css";
import { Footer, useConfirm } from "@components";
import { Link, useNavigate } from "react-router-dom";
import { homeState, defaultHomeState } from "@pages/state.js";
import { useAtom } from "jotai";
import { useCheckLogin, useLoadReset } from "@hooks";
import Axios from "@/Axios";

const Home = React.memo(function () {
  const loadReset = useLoadReset();
  const confirm = useConfirm();
  const [state, setState] = useAtom(homeState);
  const resetState = () => {
    setState({ ...defaultHomeState });
    loadReset();
  };
  const checkLogin = useCheckLogin();
  const navigate = useNavigate();

  const toLogin = () => {
    setState((s) => ({ ...s, clickedCount: s.clickedCount + 1 }));
  };
  const findAll = () => {
    Axios.get("/api/home/list", { params: {} }).then((res) => {
      if (res.data?.errMsg) {
        confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        return;
      }
      const homes = res?.data?.homes;
      const data = homes ? homes[0] : {};
      setState((s) => ({
        ...s,
        homeNm: data.homeMenuNm,
        reelsNm: data.reelsMenuNm,
        productsNm: data.productsMenuNm,
        detailNm: data.detailMenuNm,
        isViewFlags: data.isViewFlags,
      }));
    });
  };

  useEffect(() => {
    findAll();
    const callbackId = checkLogin(
      () => {
        setState((s) => ({ ...s, isLogin: true }));
      },
      () => {
        setState((s) => ({ ...s, isLogin: false }));
      }
    );
    return () => {
      cancelIdleCallback(callbackId);
      resetState();
    };
  }, []);

  // 관리자 로그인 페이지 이동
  useEffect(() => {
    if (state.clickedCount >= 10) {
      navigate("/admin-login");
    }
  }, [state.clickedCount]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.siteName}>
              <div className={styles.hatoMomInfo} onClick={toLogin}>
                <img
                  src={`${process.env.PUBLIC_URL}/favicon.ico`}
                  className={styles.brandMark}
                />
                소아작업치료사 하또맘
              </div>
            </div>
          </div>
          <div className={styles.subTitleArea}>
            <div className={styles.menuButtonArea}>
              <span className={styles.menuStructure}>메뉴 구성</span>
              {state.isLogin && (
                <Link to="/home-update" className={styles.registerUpdateButton}>
                  <span className={styles.register}>수정</span>
                </Link>
              )}
            </div>
          </div>
          <div className={styles.menuList}>
            <div className={styles.menuArea}>
              <Link to="/career-background" className={styles.menuImage} />
              <div className={styles.titleDescription}>
                <div className={styles.title}>
                  <span className={styles.homeScreen}>이력</span>
                </div>
                <div className={styles.description}>
                  <span className={styles.productList}>
                    하또맘의 이력 정보를 확인하실 수 있습니다
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.menuArea}>
              <Link to="/ai" className={styles.aiImage} />
              <div className={styles.depthFrame}>
                <div className={styles.titleD}>
                  <span className={styles.advancedInfo}>배변 훈련 AI</span>
                </div>
                <div className={styles.descriptionE}>
                  <span className={styles.productList}>
                    응용 행동 분석(ABA) 기반 배변 훈련 정보를 AI에게 물어볼 수
                    있습니다.
                  </span>
                </div>
              </div>
            </div>
            {state.isViewFlags.reels && (
              <div className={styles.menuArea}>
                <Link to="/reels-category" className={styles.menuImage2} />
                <div className={styles.titleDescription3}>
                  <div className={styles.title4}>
                    <span className={styles.releaseList}>{state.reelsNm}</span>
                  </div>
                  <div className={styles.description5}>
                    <span className={styles.productList}>
                      카테고리별로 분류된 릴스를 시청할 수 있습니다
                    </span>
                  </div>
                </div>
              </div>
            )}
            {state.isViewFlags.products && (
              <div className={styles.menuArea}>
                <Link to="/product-list" className={styles.menuImage7} />
                <div className={styles.titleDescription8}>
                  <div className={styles.title9}>
                    <span className={styles.productIntroduction}>
                      {state.productsNm}
                    </span>
                  </div>
                  <div className={styles.descriptionA}>
                    <span className={styles.productList}>
                      추천 상품 및 공동 구매 가능한 상품의 목록을 확인할 수
                      있습니다
                    </span>
                  </div>
                </div>
              </div>
            )}
            {/* 심화정보 오픈 메뉴에서 제외. 추후 다시 오픈 예정 */}
            {/* {state.isViewFlags.detail && (
              <div className={styles.menuArea}>
                <Link to="/detail-category" className={styles.menuImageC} />
                <div className={styles.depthFrame}>
                  <div className={styles.titleD}>
                    <span className={styles.advancedInfo}>
                      {state.detailNm}
                    </span>
                  </div>
                  <div className={styles.descriptionE}>
                    <span className={styles.productList}>
                      아동 발달에 대한 심화 정보를 제공합니다
                    </span>
                  </div>
                </div>
              </div>
            )} */}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
});

export default Home;
